import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let AdminManageDepartmentAccessibilityModal = class AdminManageDepartmentAccessibilityModal extends Vue {
    constructor() {
        super(...arguments);
        this.reasonText = '';
    }
    async created() { }
    resultRetrieved() {
        this.$emit('closeModal');
    }
    manageDepartmentAccessibility() {
        this.$validator.validateAll().then(async (result) => {
            if (result) {
                this.department.disableStatus.isDisabled
                    ? this.$emit('enableDepartment', this.department)
                    : this.$emit('disableDepartment', this.department, this.reasonText);
            }
        });
    }
};
__decorate([
    Prop({ type: Object })
], AdminManageDepartmentAccessibilityModal.prototype, "department", void 0);
AdminManageDepartmentAccessibilityModal = __decorate([
    Component
], AdminManageDepartmentAccessibilityModal);
export default AdminManageDepartmentAccessibilityModal;
